<template>
    <div class="container-fluid mt-2">
        <div class="row">
            <div class="col">
                <h5>Artykuły 
                    <router-link class="btn btn-circle torre-red" :to="{ name: 'articlesNew' }" title="Dodaj wydatek" v-if="isAdmin()">
                        <i class="material-icons" >
                        add
                        </i>
                    </router-link>
                </h5>
            </div>
        </div>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th class="">
                        <div class="input-group-sm mb-2">
                            <input class="form-control" @keyup="onTextChanged" v-model="form.title"/>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Data</label>
                        </div>
                    </th>
                    <th class="align-top" v-if="isAdmin()"></th>
                    <th class="align-top"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in articles" :key="item.articleId">
                    <td>{{ item.title }}</td>
                    <td>{{ formatDate(item.createdAt) }}</td>
                    <td v-if="isAdmin()"><router-link :to="{ name: 'articlesEdit', params: { id: item.articleId} }">edytuj</router-link></td>
                    <td><router-link :to="{ name: 'articlesShow', params: { id: item.articleId} }">czytaj</router-link></td>
                </tr>
            </tbody>
        </table>
        <div v-if="showEmptyResult" class="row">
            <div class="col text-center">
                Brak wyników
            </div>
        </div>
        <common-pagination @paginationClicked="onPaginationClicked"/>
    </div>
</template>
<script>
import alertify from 'alertifyjs';
import un from 'underscore'
import ArticlesService from "@/components/articles/ArticlesService"

const articlesService = new ArticlesService()
import Formatter from "@/service/Formatter"
const formatter = new Formatter()

export default {
    name: "ArticlesList",
    data: function() {
        return {
            loading: false,
            articles: [],
            pageable: {
                itemsPage: 0,
                itemsSize: 60
            },
            form: {
                title: ""
            }
        }
    },
    watch: {
        $route(to) {
            this.pageable.itemsPage = to.query.itemsPage || 0
            this.form.title = to.query.title || ""
            this.loadArticles()
        },
    },
    computed: {
        showEmptyResult() {
            return this.loading === false && this.articles.length === 0
        }
    },
    mounted() {
        this.setupParams()
        this.loadArticles()
    },
    methods: {
        formatDate(articleDate) {
            return formatter.date.YMD(articleDate)
        },
        isAdmin() {
            return articlesService.isAdmin()
        },
        setupParams() {
            this.pageable.itemsPage = this.$route.query.itemsPage || 0
            this.form.title = this.$route.query.title || ""
        },
        loadArticles() {
            this.loading = true
            const requestData = {
                params: {
                    title: this.form.title
                },
                pageable: this.pageable
            }
            articlesService.searchArticles(requestData, this.onLoadArticlesSuccess, this.onLoadArticlesError)
        },
        onLoadArticlesSuccess(data) {
            this.loading = false
            this.articles = data.items
            this.$emit('dataChanged', {
                data: data
            });
        },
        onLoadArticlesError(err) {
            this.loading = false
        },
        onPaginationClicked(payload) {
            this.$router.push({ path: 'articles', query: { itemsPage: payload.pageToSend, title: this.form.title } })
        },
        onTextChanged: un.debounce(function (e) {
            this.pageable.page = 0;
            //this.loadArticles();
            this.$router.push({ path: 'articles', query: { itemsPage: this.pageable.page, title: this.form.title } })
        }, 300)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/articles/ArticlesList.vue